import { useCallback } from 'react'
import { useTar } from '@/modules/i18n'
import { formatDuration } from './severity'

export const useFormatDuration = () => {
  const { t } = useTar()
  // Stable per language, so callers can list it as a memo dependency.
  return useCallback((ms: number) => formatDuration(ms, { s: t('adminActivityReport.units.s'), m: t('adminActivityReport.units.m'), h: t('adminActivityReport.units.h') }), [t])
}
